module.exports = __webpack_public_path__ + "img/tools2.b33caa01.png";